// removed by extract-text-webpack-plugin
module.exports = {"body":"_-src-components-FilterMenu-PlacementSelectorModal---body---14EQ-","description":"_-src-components-FilterMenu-PlacementSelectorModal---description---2ARjf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FilterMenu/PlacementSelectorModal.css
// module id = 757
// module chunks = 0